module.exports = __webpack_public_path__ + "static/media/bibeo.657e9894.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bibeo.jpg
 ** module id = 668
 ** module chunks = 0
 **/